// Constructores puros de nodos del árbol de prorrateo (TreeClassificator) y la
// distribución de montos por la cadena cuenta→atributo→subatributo. Extraídos
// del componente para testearlos aislados; no tocan estado de Vue.
//
// `randomId` es una función que devuelve un id negativo único (placeholder de
// los nodos nuevos, que todavía no tienen id de BD). Se inyecta para que estas
// funciones sean puras (el componente pasa su `getRandomNegativeInt`).

export function emptyAttribute(account, randomId, types = []) {
	return {
		id: randomId(),
		fakeId: randomId(),
		doc_attributed: null,
		percentage: 0,
		attribute: types[0],
		attrs: 1,
		parentAccount: account,
	};
}

export function emptySubAttribute(attr, randomId, types = []) {
	return {
		id: randomId(),
		fakeId: randomId(),
		doc_attributed: null,
		percentage: 0,
		attribute: types[1],
		attrs: 1,
		parentAttr: attr,
		paVisible: false,
		grandpaVisible: false,
	};
}

// Una línea completa cuenta→atributo→subatributo vacía (para "agregar cuenta").
export function emptySubAttrLine(randomId, types = []) {
	const grandpa = {
		id: randomId(),
		fakeId: randomId(),
		account: -1,
		doc_attributed: null,
		percentage: 0,
		attrs: 1,
	};
	const pa = emptyAttribute(grandpa, randomId, types);
	return emptySubAttribute(pa, randomId, types);
}

export function createEmptyAttr(type, account, attr, randomId) {
	return {
		id: randomId(),
		doc_attributed: null,
		classified_attribute: -1,
		percentage: 100,
		attribute_type: type,
		parent_account: account,
		parent_attr: attr,
	};
}

// Reparte el monto del documento (`localMoney`) por la cadena, usando los
// porcentajes ya calculados en cada nivel. Muta `subAttrib` in place y lo
// devuelve (igual que el método original).
export function calculateAllAmountsTree(subAttrib, localMoney) {
	subAttrib.parentAttr.parentAccount.money = parseInt(localMoney * subAttrib.parentAttr.parentAccount.percentage / 100);
	subAttrib.parentAttr.money = parseInt(subAttrib.parentAttr.parentAccount.money * subAttrib.parentAttr.percentage / 100);
	subAttrib.money = parseInt(subAttrib.parentAttr.money * subAttrib.percentage / 100);
	return subAttrib;
}
